import React from 'react';
import PropTypes from 'prop-types';

import Link, { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import TextButton from '../../../01_atoms/TextButton';
import FormattedText from '../../../01_atoms/FormattedText';
import SectionBg from '../../../../public/static/icons/global-goals/section-bg.svg';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBActivismGoals = ({ title, text, button, behaviorSettings = null, uuid = null }) => (
  <div
    className={`bb ${styles['bb-activism-goals']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    id={uuid}
  >
    <div className="container">
      <div className={styles['bb-activism-goals__content-wrapper']}>
        <div className={styles['bb-activism-goals__content-container']}>
          <div className={styles['bb-activism-goals__wheel']}>
            <div className={styles['wheel']}>
              {[...Array(17)].map((x, i) => (
                <div
                  key={`item-${i}`}
                  className={`${styles['wheel__section']} ${styles[`wheel__section--${i + 1}`]}`}
                >
                  <SectionBg className={styles['wheel__section-bg']} />
                  <div className={styles['wheel__icon-wrapper']}>
                    <div className={styles['wheel__icon']}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles['bb-activism-goals__content']}>
            <h2 className={styles['bb-activism-goals__title']}>{title}</h2>

            <FormattedText className={styles['bb-activism-goals__text']} text={text} />

            <div className={styles['bb-activism-goals__action']}>
              <Link {...button.nextLink}>
                <TextButton withArrow tag="a" href={button.nextLink.url}>
                  {button.label}
                </TextButton>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

BBActivismGoals.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    nextLink: PropTypes.shape(linkPropTypes).isRequired,
  }).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBActivismGoals;
